import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import FromKitchenToHomeBanner from '../../assets/from-our-kitchen-to-your-home-banner_second.jpg';
import { getDeviceType } from '../../utils/common';
import { pageAction } from '../../redux_files/actions/page_actions';

const FromKitchenToHome = () => {
	const dispatch = useDispatch();
	const [deviceType, setDeviceType] = useState(getDeviceType());
	useEffect(() => {
		window.addEventListener('resize', setDeviceType(getDeviceType()));
		return () => window.removeEventListener(`resize`, setDeviceType(getDeviceType()));
	}, []);

	useEffect(() => {
		document.title = 'Blogs | From Our Kitchen to Your Heart – Just Like Home';
		dispatch(pageAction('Feels Like Home'));
	});
	return (
		<>
			<img src={FromKitchenToHomeBanner} alt='Banner' width='100%' height={deviceType !== "mobile" ? "500" : "200"} />
			<div className='container'>
				<article>
					{deviceType === "mobile" ? <h3>From Our Kitchen to Your Heart – Just Like Home</h3> : <h2>From Our Kitchen to Your Heart – Just Like Home</h2>}
					<p><strong>by Shivay Durga Foods</strong></p>

					<p>In today`s world of fast food, instant meals, and rushed routines, there`s one thing we all crave more than convenience — <strong>comfort</strong>. And nothing brings comfort quite like <strong>home-cooked food</strong>. The aroma of dal sizzling in ghee, the warmth of freshly made chapatis, the familiar taste of mom`s secret masala — these little things don`t just fill our stomachs, they <em>nourish our souls</em>.</p>

					<p>At <strong>Shivay Durga Foods</strong>, we believe food isn`t just about ingredients. It`s about memories, love, and a sense of belonging. That`s why our mission is simple: <br />
						<em>To bring the taste of home to those who are far from it.</em></p>

					<h2>A Kitchen That Cooks with Care</h2>
					<p>Every dish we serve starts in a kitchen that mimics your home. No factories. No assembly lines. Just a team of passionate cooks who prepare each meal with the same love and attention they would for their own families.</p>
					<p>We don`t rush meals; we respect them. From handpicking fresh vegetables to slow-cooking gravies to perfection, every step is a tribute to traditional Indian cooking. At <strong>Shivay Durga Foods</strong>, it`s not just about <em>what</em> we cook — it`s about <em>how</em> we cook.</p>

					<h2>For Students, Professionals & Everyone In Between</h2>
					<p>We understand what it`s like to be away from home — juggling classes, long workdays, or managing life in a new city. The last thing you want is a bland, packaged meal. You deserve more than that. You deserve food that <strong>feels familiar</strong>, food that <strong>feels like home</strong>.</p>

					<p>That`s why <strong>Shivay Durga Foods</strong> offers meals that are:</p>
					<p><strong>Wholesome:</strong> Balanced nutrition to keep you energized<br />
						<strong>Affordable:</strong> Priced to fit student and working budgets<br />
						<strong>Consistent:</strong> Same great taste, every single day<br />
						<strong>Safe & Hygienic:</strong> Because care starts with cleanliness</p>

					<h2>Not Just Food, But a Feeling</h2>
					<p>What makes our meals special isn`t just the spices or recipes. It`s the idea that you`re not alone. That even if you`re miles away from home, there`s someone thinking of your health, your hunger, and your happiness.</p>
					<p>Every bite should remind you of something — Sunday lunches, dinner with cousins, late-night cravings answered by mom, or your dad`s favorite sabzi. At <strong>Shivay Durga Foods</strong>, we bring those memories to your plate, one meal at a time.</p>

					<h2>Let Shivay Durga Foods Be Your Home Away From Home</h2>
					<p>Whether you`re missing your hometown or just looking for food that feels more <em>real</em>, let us serve you. With every box we deliver, we promise you warmth, nourishment, and a little piece of home.</p>

					<p>Because here, in our kitchen, we are not just cooking meals — <br />
						<strong>We are delivering love.</strong></p>
				</article>
			</div>
		</>
	);
};
export default FromKitchenToHome;
